import React, { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import formatErrorToString from '../helpers/formatErrorToString';
import { useTranslation } from 'react-i18next';

const FONT_SIZE = '13px';

export default function useNotify() {
    const { t } = useTranslation();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { logoutUser } = useAuth();
    const navigate = useNavigate();
    const notifySuccess = useCallback(
        (message, persist = false) => {
            enqueueSnackbar(message, {
                variant: 'success',
                style: { fontSize: FONT_SIZE },
                persist,
                action: persist
                    ? (key) => {
                          return (
                              <Button onClick={() => closeSnackbar(key)}>
                                  {t('common.close')}
                              </Button>
                          );
                      }
                    : undefined,
            });
        },
        [enqueueSnackbar, closeSnackbar, t],
    );
    const notifyInfo = useCallback(
        (message, persist = false) => {
            enqueueSnackbar(message, {
                variant: 'info',
                style: { fontSize: FONT_SIZE },
                persist,
                action: persist
                    ? (key) => {
                          return (
                              <Button onClick={() => closeSnackbar(key)}>
                                  {t('common.close')}
                              </Button>
                          );
                      }
                    : undefined,
            });
        },
        [enqueueSnackbar, closeSnackbar, t],
    );
    const notifyError = useCallback(
        (error) => {
            let stringMessage = formatErrorToString(error);
            try {
                if (
                    (error?.response?.obj?.code &&
                        error?.response?.obj?.message === 'Session expired. Please Login.') ||
                    (error?.response?.body?.code &&
                        error?.response?.body?.message === 'Session expired. Please Login.') ||
                    (error?.response?.obj?.code &&
                        error?.response?.obj?.message === 'Invalid jwt token') ||
                    (error?.response?.body?.code &&
                        error?.response?.body?.message === 'Invalid jwt token')
                ) {
                    logoutUser();
                    navigate('/');
                }
            } catch (err) {
                console.log(err);
                stringMessage = t('errors.somethingWentWrong');
            }

            enqueueSnackbar(stringMessage, {
                variant: 'error',
                persist: true,
                style: { fontSize: FONT_SIZE },
                action: (key) => {
                    return (
                        <Button
                            variant="text"
                            style={{ color: 'white' }}
                            onClick={() => closeSnackbar(key)}
                        >
                            Close
                        </Button>
                    );
                },
            });
        },
        [enqueueSnackbar, closeSnackbar, logoutUser, navigate, t],
    );

    return {
        notifySuccess,
        notifyError,
        notifyInfo,
    };
}
